import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from 'hooks/useAuth/useAuth';
import { Icon } from '@ontruck/orc';
import { usePushNotifications } from 'hooks/usePushNotifications/usePushNotifications';

const NotificationsBar = ({ className }) => {
  const { t } = useTranslation('Login');
  const { termsAccepted } = useAuth();
  const [show, setShow] = useState(true);
  const {
    activatePushNotifications,
    userSubscription,
    userConsent,
    pushNotificationSupported
  } = usePushNotifications();

  if (
    !pushNotificationSupported ||
    !termsAccepted ||
    !show ||
    userSubscription ||
    userConsent !== 'default'
  )
    return null;

  const handleCloseIcon = () => {
    setShow(false);
  };

  return (
    <div className={className} data-testid="notifications-bar">
      <div className="notifications-bar">
        <span className="notifications-bar__label">
          <button
            className="notifications-bar__button notifications-bar__button--inline"
            onClick={() => {
              activatePushNotifications();
            }}
          >
            {t('pushNotifications')}
          </button>
        </span>
        <button
          className="notifications-bar__button notifications-bar__close"
          onClick={handleCloseIcon}
        >
          <Icon glyph="close" size="2rem"></Icon>
        </button>
      </div>
    </div>
  );
};
export default NotificationsBar;
